import React, { useMemo } from 'react';
import { Group } from 'react-konva';
import { distanceBetweenDots, distanseBetweenLayers, ballDiametr, dotDiametr, BallPositionByDot, coeffElementHeight, coeffElementWidth, coeffOffset } from '../initials';
import Dots from '../Dotes';
import Ball from '../Ball';
import Coefficients from '../Coefficients';
import { useDots } from '../hooks/useDots';
import { useBallPositions } from '../hooks/useBallPositions';
import { useCoeffsArray } from '../hooks/useCoeffsArray';
import { useAnimation } from '../hooks/useAnimation';
import { AnimationChainFactory } from '../animations/AnimationChainFactory';
import { JumpFromDotToDotLineStartTopLeft } from '../animations/FromDotToDotLine/JumpFromDotToDotLineStartTopLeft';
import { JumpFromDotToDotLineStartTopLeftEndBottomRight } from '../animations/FromDotToDotLine/JumpFromDotToDotLineStartTopLeftEndBottomRight';
import { JumpFromDotToDotLineStartTopRight } from '../animations/FromDotToDotLine/JumpFromDotToDotLineStartTopRight';
import { JumpFromDotToDotLineStartTopRightEndBottomLeft } from '../animations/FromDotToDotLine/JumpFromDotToDotLineStartTopRightEndBottomLeft';
import { JumpFromDotToDotWithMiniBounce } from '../animations/FromDotToDotWithMiniBounce/JumpFromDotToDotWithMiniBounce';
import { JumpFromDotToDotWithMiniBounceCenterTopLeft } from '../animations/FromDotToDotWithMiniBounce/JumpFromDotToDotWithMiniBounceCenterTopLeft';
import { JumpFromDotToDotWithMiniBounceCenterTopRight } from '../animations/FromDotToDotWithMiniBounce/JumpFromDotToDotWithMiniBounceCenterTopRight';
import { JumpFromDotToDotWithMiniBounceTopLeftCenter } from '../animations/FromDotToDotWithMiniBounce/JumpFromDotToDotWithMiniBounceTopLeftCenter';
import { JumpFromDotToDotWithMiniBounceTopLeftTopRight } from '../animations/FromDotToDotWithMiniBounce/JumpFromDotToDotWithMiniBounceTopLeftTopRight';
import { JumpFromDotToDotWithMiniBounceTopRightCenter } from '../animations/FromDotToDotWithMiniBounce/JumpFromDotToDotWithMiniBounceTopRightCenter';
import { JumpFromDotToDotWithMiniBounceTopRightTopLeft } from '../animations/FromDotToDotWithMiniBounce/JumpFromDotToDotWithMiniBounceTopRightTopLeft';
import { JumpFromDotToDot } from '../animations/JumpFromDotToDot/JumpFromDotToDot';
import { JumpFromDotToDotStartCenterEndBottomLeft } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartCenterEndBottomLeft';
import { JumpFromDotToDotStartCenterEndBottomRight } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartCenterEndBottomRight';
import { JumpFromDotToDotStartCenterEndTopLeft } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartCenterEndTopLeft';
import { JumpFromDotToDotStartCenterEndTopRight } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartCenterEndTopRight';
import { JumpFromDotToDotStartTopLeftEndBottomRight } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartTopLeftEndBottomRight';
import { JumpFromDotToDotStartTopLeftEndCenter } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartTopLeftEndCenter';
import { JumpFromDotToDotStartTopLeftEndTopRight } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartTopLeftEndTopRight';
import { JumpFromDotToDotStartTopRightEndBottomLeft } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartTopRightEndBottomLeft';
import { JumpFromDotToDotStartTopRightEndCenter } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartTopRightEndCenter';
import { JumpFromDotToDotStartTopRightEndTopLeft } from '../animations/JumpFromDotToDot/JumpFromDotToDotStartTopRightEndTopLeft';
import { JumpFromDotToDotWithBounce } from '../animations/JumpFromDotToDotWithBounce/JumpFromDotToDotWithBounce';
import { JumpFromDotToDotWithBounceCenterTopLeft } from '../animations/JumpFromDotToDotWithBounce/JumpFromDotToDotWithBounceCenterTopLeft';
import { JumpFromDotToDotWithBounceCenterTopRight } from '../animations/JumpFromDotToDotWithBounce/JumpFromDotToDotWithBounceCenterTopRight';
import { JumpFromDotToDotWithBounceTopLeftCenter } from '../animations/JumpFromDotToDotWithBounce/JumpFromDotToDotWithBounceTopLeftCenter';
import { JumpFromDotToDotWithBounceTopLeftTopRight } from '../animations/JumpFromDotToDotWithBounce/JumpFromDotToDotWithBounceTopLeftTopRight';
import { JumpFromDotToDotWithBounceTopRightCenter } from '../animations/JumpFromDotToDotWithBounce/JumpFromDotToDotWithBounceTopRightCenter';
import { JumpFromDotToDotWithBounceTopRightTopLeft } from '../animations/JumpFromDotToDotWithBounce/JumpFromDotToDotWithBounceTopRightTopLeft';
import { Parabolic } from '../animations/Parabolic/Parabolic';
import { ParabolicCenterTopLeft } from '../animations/Parabolic/ParabolicCenterTopLeft';
import { ParabolicCenterTopRight } from '../animations/Parabolic/ParabolicCenterTopRight';
import { ParabolicTopLeftCenter } from '../animations/Parabolic/ParabolicTopLeftCenter';
import { ParabolicTopLeftTopRight } from '../animations/Parabolic/ParabolicTopLeftTopRight';
import { ParabolicTopRightCenter } from '../animations/Parabolic/ParabolicTopRightCenter';
import { ParabolicTopRightTopLeft } from '../animations/Parabolic/ParabolicTopRightTopLeft';
import { ParabolicAnimation } from '../animations/ParabolicAnimation/ParabolicAnimation';
import { ParabolicAnimationCenterTopLeft } from '../animations/ParabolicAnimation/ParabolicAnimationCenterTopLeft';
import { ParabolicAnimationCenterTopRight } from '../animations/ParabolicAnimation/ParabolicAnimationCenterTopRight';
import { ParabolicAnimationTopLeftCenter } from '../animations/ParabolicAnimation/ParabolicAnimationTopLeftCenter';
import { ParabolicAnimationTopLeftTopRight } from '../animations/ParabolicAnimation/ParabolicAnimationTopLeftTopRight';
import { ParabolicAnimationTopRightCenter } from '../animations/ParabolicAnimation/ParabolicAnimationTopRightCenter';
import { ParabolicAnimationTopRightTopLeft } from '../animations/ParabolicAnimation/ParabolicAnimationTopRightTopLeft';
import { LineBottomLeftTopRight } from '../animations/Line/LineBottomLeftTopRight';
import { LineBottomLeftCenter } from '../animations/Line/LineBottomLeftCenter';
import { LineBottomRightCenter } from '../animations/Line/LineBottomRightCenter';
import { LineBottomRightTopLeft } from '../animations/Line/LineBottomRightTopLeft';
import { EndSimpleFallAnimation } from '../animations/EndSimpleFallAnimation/EndSimpleFallAnimation';
import { EndSimpleFallAnimationStartTopLeft } from '../animations/EndSimpleFallAnimation/EndSimpleFallAnimationStartTopLeft';
import { EndSimpleFallAnimationStartTopRight } from '../animations/EndSimpleFallAnimation/EndSimpleFallAnimationStartTopRight';
import { FinaleLineAnimationBottomLeft } from '../animations/FinaleLineAnimation/FinaleLineAnimationBottomLeft';
import { FinaleLineAnimationBottomRight } from '../animations/FinaleLineAnimation/FinaleLineAnimationBottomRight';
import { FinaleLineAnimationTopLeft } from '../animations/FinaleLineAnimation/FinaleLineAnimationTopLeft';
import { FinaleLineAnimationTopRight } from '../animations/FinaleLineAnimation/FinaleLineAnimationTopRight';
import { LineTopRightCenter } from '../animations/Line/LineTopRightCenter';
import { LineTopLeftCenter } from '../animations/Line/LineTopLeftCenter';
import { JumpFromDotToDotLineStartCenterTopRight } from '../animations/FromDotToDotLine/JumpFromDotToDotLineStartCenterTopRight';
import { JumpFromDotToDotLineStartCenterTopLeft } from '../animations/FromDotToDotLine/JumpFromDotToDotLineStartCenterTopLeft';

const availableAnimations = [
  Parabolic,
  ParabolicCenterTopLeft,
  ParabolicCenterTopRight,
  ParabolicTopLeftCenter,
  ParabolicTopLeftTopRight,
  ParabolicTopRightCenter,
  ParabolicTopRightTopLeft,
  ParabolicAnimation,
  ParabolicAnimationCenterTopLeft,
  ParabolicAnimationCenterTopRight,
  ParabolicAnimationTopLeftCenter,
  ParabolicAnimationTopLeftTopRight,
  ParabolicAnimationTopRightCenter,
  ParabolicAnimationTopRightTopLeft,
  LineBottomLeftCenter,
  LineBottomLeftTopRight,
  LineBottomRightCenter,
  LineBottomRightTopLeft,
  LineTopRightCenter,
  LineTopLeftCenter,
];

const oneLevelAnimations = [
  JumpFromDotToDotLineStartTopLeft,
  JumpFromDotToDotLineStartTopLeftEndBottomRight,
  JumpFromDotToDotLineStartTopRight,
  JumpFromDotToDotLineStartTopRightEndBottomLeft,
  JumpFromDotToDotLineStartCenterTopRight,
  JumpFromDotToDotLineStartCenterTopLeft,
  JumpFromDotToDotWithMiniBounce,
  JumpFromDotToDotWithMiniBounceCenterTopLeft,
  JumpFromDotToDotWithMiniBounceCenterTopRight,
  JumpFromDotToDotWithMiniBounceTopLeftCenter,
  JumpFromDotToDotWithMiniBounceTopLeftTopRight,
  JumpFromDotToDotWithMiniBounceTopRightCenter,
  JumpFromDotToDotWithMiniBounceTopRightTopLeft,
  JumpFromDotToDot,
  JumpFromDotToDotStartCenterEndBottomLeft,
  JumpFromDotToDotStartCenterEndBottomRight,
  JumpFromDotToDotStartCenterEndTopLeft,
  JumpFromDotToDotStartCenterEndTopRight,
  JumpFromDotToDotStartTopLeftEndBottomRight,
  JumpFromDotToDotStartTopLeftEndCenter,
  JumpFromDotToDotStartTopLeftEndTopRight,
  JumpFromDotToDotStartTopRightEndBottomLeft,
  JumpFromDotToDotStartTopRightEndCenter,
  JumpFromDotToDotStartTopRightEndTopLeft,
  JumpFromDotToDotWithBounce,
  JumpFromDotToDotWithBounceCenterTopLeft,
  JumpFromDotToDotWithBounceCenterTopRight,
  JumpFromDotToDotWithBounceTopLeftCenter,
  JumpFromDotToDotWithBounceTopLeftTopRight,
  JumpFromDotToDotWithBounceTopRightCenter,
  JumpFromDotToDotWithBounceTopRightTopLeft,
];

const finalAnimations = [
  EndSimpleFallAnimation,
  FinaleLineAnimationBottomLeft,
  FinaleLineAnimationBottomRight,
  EndSimpleFallAnimationStartTopLeft,
  EndSimpleFallAnimationStartTopRight,
  FinaleLineAnimationTopLeft,
  FinaleLineAnimationTopRight,
];

const disabledChains = {
  doubleBounce: ['doubleBounceWithVerticalBounce'],
  doubleBounceWithVerticalBounce: ['doubleBounce'],
  jumpFromDotToDot: ['doubleBounce', 'doubleBounceWithVerticalBounce'],
};

const disabledDirection = {
  [BallPositionByDot.BOTTOM_LEFT]: [BallPositionByDot.BOTTOM_LEFT, BallPositionByDot.TOP_LEFT],
  [BallPositionByDot.BOTTOM_RIGHT]: [BallPositionByDot.BOTTOM_RIGHT, BallPositionByDot.TOP_RIGHT],
  [BallPositionByDot.TOP_LEFT]: [BallPositionByDot.TOP_LEFT, BallPositionByDot.BOTTOM_LEFT],
  [BallPositionByDot.TOP_RIGHT]: [BallPositionByDot.TOP_RIGHT, BallPositionByDot.BOTTOM_RIGHT],
}

const animationFactory = new AnimationChainFactory({
  availableAnimations,
  disabledChains,
  oneLevelAnimations,
  disabledDirection,
  finalAnimations,
});

const Pyramid = ({ coeffs, height, widthCanvas, onEndGame, heightCanvas, activeBalls }) => {
  const dotsArr = useDots({
    height,
    widthCanvas,
    heightCanvas,
  });

  const scaleKonvas = useMemo(() => {
    const scaleX = (widthCanvas / ((dotsArr[height - 1].length - 1) * (distanceBetweenDots + dotDiametr)));
    const scaleY = (heightCanvas / (height * (distanseBetweenLayers + dotDiametr) + coeffElementHeight));

    return Math.min(scaleX, scaleY);

  }, [widthCanvas, heightCanvas, dotsArr, height]);

  const [ballPositions, changeBallPosition] = useBallPositions({
    activeBalls,
    widthCanvas,
  });

  const {
    coeffsArray,
    highlightCoeff
  } = useCoeffsArray({
    coeffs,
    height,
    dotsArr,
  });

  const piramidHeight = dotsArr[dotsArr.length-1][0].dotY - dotsArr[0][0].dotY + coeffOffset + coeffElementHeight;

  useAnimation({
    coeffsArray,
    highlightCoeff,
    changeBallPosition,
    ballPositions,
    animationFactory,
    dotsArr,
    onEndGame,
  });

  return (
      <Group scale={{ x: scaleKonvas, y: scaleKonvas }} x={widthCanvas / 2 - (distanceBetweenDots * scaleKonvas) * (dotsArr[height - 1].length - 1) / 2} y={(heightCanvas - piramidHeight * scaleKonvas) / 2}>
        {dotsArr.map((row, i) => (
          <Dots dotsArr={row} key={i} />
        ))}
        {ballPositions.map((ballPosItem, i) => (
          <Ball key={i} xPos={ballPosItem.x} yPos={ballPosItem.y} width={ballDiametr} height={ballDiametr} />
        ))}
        {coeffsArray.map((item, i) => <Coefficients key={i} text={item.value} color={item.color} xPosition={item.x} yPosition={item.y} elemHeight={coeffElementHeight} elemWidth={coeffElementWidth} isHighlighted={item.isHighlighted} textColor={item.textColor} />)}
      </Group>
  );
};

export default Pyramid;
